import { ColumnSortTrigger } from '../shared/columnSortTrigger';
import stringHelpers from '../../utilities/stringHelpers';
import roleUtilities from '../../utilities/roleUtilities';
import arrayUtilities from '../../utilities/arrayUtilities';
import { Link, useLocation } from 'react-router-dom';
import { toDateTimeString, isDateTimeElapsed } from '../../utilities/dateUtilities';
import Loader from '../shared/loader';
import { ToggleWithLocalisedLoading } from '../shared/toggleWithLocalisedLoading';
import { disallowedVrmEnableDisable } from '../../utilities/allowListUtilities';

export const DisallowListTable = ({ disallowList, handleSortTriggerClick, isThirdPartyUser, currentSortBy, user, handleCheckChange, setDisallowList, isLoading, setErrorMessage, organisationId, token, allowDelete, hideEnableToggle }) => {
    const location = useLocation();

    return (
        <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer allow-list-table">
            <thead className="bg-200 text-900">
                <tr>
                    { !isThirdPartyUser && allowDelete && <th>&nbsp;</th> }
                    <th>
                        <ColumnSortTrigger
                            onClick={ direction => handleSortTriggerClick(0, direction) }
                            currentSortBy={ currentSortBy }
                            sortBy={ 0 }
                            localStorageKey={ `${ user.id }-disallowListSortPreference` }
                            label="VRM"
                        />
                    </th>
                    <th>Driver Name</th>
                    <th>Vehicle</th>
                    <th>Site(s)</th>
                    <th>
                        <ColumnSortTrigger
                            onClick={ direction => handleSortTriggerClick(1, direction) }
                            currentSortBy={ currentSortBy }
                            sortBy={ 1 }
                            localStorageKey={ `${ user.id }-disallowListSortPreference` }
                            label="Start Date"
                        />
                    </th>
                    <th>End Date</th>
                    <th>
                        <ColumnSortTrigger
                            onClick={ direction => handleSortTriggerClick(3, direction) }
                            currentSortBy={ currentSortBy }
                            sortBy={ 3 }
                            localStorageKey={ `${ user.id }-disallowListSortPreference` }
                            label="Created Date"
                        />
                    </th>
                    <th>Created By</th>
                    <th className='text-center'>Enabled</th>
                </tr>
            </thead>
            <tbody>
                {
                    isLoading
                        ? <tr><td colSpan={ 12 }><Loader /></td></tr>
                        : <>
                            {
                                !arrayUtilities.isNullOrEmpty(disallowList) && disallowList
                                    .map((item, i) => <tr key={ item.id } className='fs--2'>
                                        { !isThirdPartyUser && allowDelete &&
                                            <td>
                                                <input
                                                    onChange={ e => handleCheckChange(e.target.value) }
                                                    value={ item.id }
                                                    type="checkbox"
                                                    id={ item.id }
                                                    name={ item.vrm }
                                                />
                                            </td> }
                                        <td><Link to={ { pathname: `/organisation/${ organisationId }/disallowed-vrm/${ item.id }`, state: { returnUrl: location.pathname } } } className="number-plate-link"><h6 className="mb-0 compact-number-plate">{ item.vrm }</h6></Link></td>
                                        <td>{ item.driverName }</td>
                                        <td><div className='allow-list-clamped-cell'>{ item.vehicleMake } { item.vehicleModel }</div></td>
                                        <td>
                                            {
                                                !stringHelpers.isNullOrEmpty(item.siteName)
                                                    ? <>{ item.siteName }</>
                                                    : !stringHelpers.isNullOrEmpty(item.clientName) ? <>{ item.clientName }</> : <>All</>
                                            }
                                        </td>
                                        <td>
                                            {
                                                !stringHelpers.isNullOrEmpty(item.startDate)
                                                    ? <>{ toDateTimeString(item.startDate) } </>
                                                    : <span>&mdash; </span>
                                            }
                                        </td>
                                        <td>
                                            {
                                                !stringHelpers.isNullOrEmpty(item.endDate)
                                                    ? <> { toDateTimeString(item.endDate) } <span className='text-end'>{ isDateTimeElapsed(item.endDate) && <i className="fas fa-exclamation-triangle text-warning ml-2 fs-1"></i> }</span></>
                                                    : <span>&mdash; </span>
                                            }
                                        </td>
                                        <td>{ !stringHelpers.isNullOrEmpty(item.createdTimestamp) && toDateTimeString(item.createdTimestamp) }</td>
                                        <td>{ item.createdByUserName }</td>
                                        <td className='text-center'>
                                            {
                                                isThirdPartyUser 
                                                || roleUtilities.isOrganisationProcessor(user, organisationId)
                                                || hideEnableToggle
                                                    ? <>
                                                        { item.isEnabled ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i> }
                                                    </>
                                                    : <ToggleWithLocalisedLoading
                                                        checked={ item.isEnabled }
                                                        id={ `${ item.id }-enable-disable-allowed-vrm` }
                                                        onChange={ isChecked => disallowedVrmEnableDisable(item.id, isChecked, setErrorMessage, setDisallowList, organisationId, token) }
                                                        loadingStateTracker={ item }
                                                    />
                                            }
                                        </td>
                                    </tr>) }
                        </>
                }
            </tbody>
        </table>
    )
}